@if (visible()) {
  <div class="modal fade" role="dialog" tabindex="-1" [class.in]="visibleAnimate()" [ngClass]="getCustomClass()">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <ng-container *ngTemplateOutlet="header"></ng-container>
          <button
            *ngIf="!shouldHideCloseButton()"
            class="close"
            data-dismiss="modal"
            type="button"
            aria-label="Close"
            (click)="close()"
          >
            ×
          </button>
        </div>
        <div class="modal-body">
          <ng-container *ngTemplateOutlet="body"></ng-container>
        </div>
        <div class="modal-footer">
          <ng-container *ngTemplateOutlet="footer"></ng-container>
        </div>
      </div>
    </div>
  </div>
}
